(function() {
    'use strict';
    
    const MAX_AGE = 30 * 60 * 1000; // 30 minutes TTL
    
    // Clean up expired breadcrumbs from sessionStorage
    function cleanExpiredBreadcrumbs() {
        const keys = Object.keys(sessionStorage);
        keys.forEach(key => {
            if (key.startsWith('breadcrumbs_')) {
                try {
                    const data = JSON.parse(sessionStorage.getItem(key));
                    if (data?.timestamp && (Date.now() - data.timestamp > MAX_AGE)) {
                        sessionStorage.removeItem(key);
                    }
                } catch (e) {
                    sessionStorage.removeItem(key);
                }
            }
        });
    }
    
    // Build breadcrumb HTML from path array
    function buildBreadcrumbHTML(breadcrumbPath, isLastItemClickable = false) {
        const homeLink = document.querySelector('.breadcrumbs .items li:first-child a');
        const homeURL = homeLink?.getAttribute('href') || '/';
        const homeTitle = homeLink?.querySelector('strong')?.textContent || 'Home';
        
        let html = `<li class="item slider__slide"><a href="${homeURL}"><strong>${homeTitle}</strong></a><i class="arrow right"></i></li>`;
        
        breadcrumbPath.forEach((item, index) => {
            const isLast = index === breadcrumbPath.length - 1;
            if (isLast && !isLastItemClickable) {
                html += `<li class="item slider__slide breadcrumb-collection-items">${item.title}</li>`;
            } else {
                html += `<li class="item slider__slide"><strong><a href="${item.url}">${item.title}</a></strong><i class="arrow right"></i></li>`;
            }
        });
        
        return html;
    }
    
    // Handle product page breadcrumbs
    function handleProductPage(pathName, breadcrumbsWrapper) {
        const productBreadcrumbContainer = document.querySelector('.items.slider.slider--desktop');
        if (!productBreadcrumbContainer) {
            breadcrumbsWrapper?.classList.add('js-ready');
            return;
        }
        
        // Get product title from the existing breadcrumbs
        const productTitle = document.querySelector('.breadcrumbs .items li:last-child')?.textContent.trim();
        
        if (!productTitle) {
            breadcrumbsWrapper?.classList.add('js-ready');
            return;
        }
        
        const breadcrumbKey = `breadcrumbs_${pathName}`;
        const storedData = sessionStorage.getItem(breadcrumbKey);
        
        // Check if we have stored breadcrumbs for this product
        if (storedData) {
            try {
                const { path, timestamp } = JSON.parse(storedData);
                
                if (path?.length && timestamp && (Date.now() - timestamp < MAX_AGE)) {
                    // Add product title as the last item
                    const completePath = [...path, { url: pathName, title: productTitle }];
                    const breadcrumbHTML = buildBreadcrumbHTML(completePath);
                    
                    productBreadcrumbContainer.outerHTML = `<ul class="items slider slider--desktop">${breadcrumbHTML}</ul>`;
                    
                    breadcrumbsWrapper?.classList.add('js-ready');
                    return;
                }
                sessionStorage.removeItem(breadcrumbKey);
            } catch (e) {
                sessionStorage.removeItem(breadcrumbKey);
            }
        }
        
        // Check for temp breadcrumbs from collection
        const referrer = document.referrer;
        if (referrer.includes('/collections/')) {
            const tempBreadcrumbs = sessionStorage.getItem('breadcrumbsMap_temp');
            if (tempBreadcrumbs) {
                try {
                    const { path, timestamp } = JSON.parse(tempBreadcrumbs);
                    
                    if (path?.length && timestamp && (Date.now() - timestamp < MAX_AGE)) {
                        // Store for this product (without product title in stored path)
                        sessionStorage.setItem(breadcrumbKey, JSON.stringify({ path, timestamp }));
                        
                        // Add product title as the last item for display
                        const completePath = [...path, { url: pathName, title: productTitle }];
                        const breadcrumbHTML = buildBreadcrumbHTML(completePath);
                        
                        productBreadcrumbContainer.outerHTML = `<ul class="items slider slider--desktop">${breadcrumbHTML}</ul>`;
                        
                        breadcrumbsWrapper?.classList.add('js-ready');
                        return;
                    }
                } catch (e) {
                    sessionStorage.removeItem('breadcrumbsMap_temp');
                }
            }
        }
        
        // No stored breadcrumbs - use default
        breadcrumbsWrapper?.classList.add('js-ready');
    }
    
    // Extract breadcrumb path from sidebar for a given link
    function extractBreadcrumbPath(activeLink) {
        const breadcrumbPath = [];
        const isGrandchild = activeLink.closest('.sidebar-menu__grandchild-menu');
        const isChild = activeLink.closest('.sidebar-menu__child-menu');
        
        if (isGrandchild) {
            // Third level: Grandparent > Parent > Child
            const childTitle = activeLink.textContent.trim();
            const childUrl = activeLink.getAttribute('href');
            
            const parentDetails = activeLink.closest('.sidebar-menu__inner-grandchild-menu')?.parentElement;
            const parentLink = parentDetails?.querySelector(':scope > summary a');
            
            const grandparentDetails = activeLink.closest('.sidebar-menu__submenu')?.parentElement;
            const grandparentLink = grandparentDetails?.querySelector(':scope > summary a');
            
            if (grandparentLink) {
                breadcrumbPath.push({
                    url: grandparentLink.getAttribute('href'),
                    title: grandparentLink.textContent.trim()
                });
            }
            if (parentLink) {
                breadcrumbPath.push({
                    url: parentLink.getAttribute('href'),
                    title: parentLink.textContent.trim()
                });
            }
            breadcrumbPath.push({ url: childUrl, title: childTitle });
            
        } else if (isChild) {
            // Second level: Parent > Child
            const childTitle = activeLink.textContent.trim();
            const childUrl = activeLink.getAttribute('href');
            const isSummaryLink = activeLink.closest('summary');
            
            if (isSummaryLink) {
                // This is a parent being viewed
                const grandparentDetails = activeLink.closest('.sidebar-menu__submenu')?.parentElement;
                const grandparentLink = grandparentDetails?.querySelector(':scope > summary a');
                
                if (grandparentLink) {
                    breadcrumbPath.push({
                        url: grandparentLink.getAttribute('href'),
                        title: grandparentLink.textContent.trim()
                    });
                }
            } else {
                // This is a child under a parent
                const parentDetails = activeLink.closest('.sidebar-menu__child-menu')?.parentElement?.parentElement?.parentElement;
                const parentLink = parentDetails?.querySelector(':scope > summary a');
                
                if (parentLink) {
                    breadcrumbPath.push({
                        url: parentLink.getAttribute('href'),
                        title: parentLink.textContent.trim()
                    });
                }
            }
            breadcrumbPath.push({ url: childUrl, title: childTitle });
            
        } else {
            // First level (top level item)
            breadcrumbPath.push({
                url: activeLink.getAttribute('href'),
                title: activeLink.textContent.trim()
            });
        }
        
        return breadcrumbPath;
    }
    
    // Handle collection page breadcrumbs
    function handleCollectionPage(pathName, breadcrumbsWrapper) {
        const collectionBreadcrumbContainer = document.querySelector('.breadcrumb-collection-items');
        
        if (!collectionBreadcrumbContainer) {
            breadcrumbsWrapper?.classList.add('js-ready');
            return;
        }
        
        const collectionTitle = collectionBreadcrumbContainer.textContent.trim();
        const breadcrumbKey = `breadcrumbs_${pathName}`;
        
        // Render breadcrumb given a PARENT path (chain excluding the current collection).
        // Persists parent path for reloads and full path for products clicked from here.
        const renderFromParentPath = (parentPath) => {
            const completePath = [...parentPath, { url: pathName, title: collectionTitle }];
            const breadcrumbHTML = buildBreadcrumbHTML(completePath);
            const ulElement = collectionBreadcrumbContainer.closest('ul.items');
            if (ulElement) {
                ulElement.outerHTML = `<ul class="items slider slider--desktop">${breadcrumbHTML}</ul>`;
            }
            sessionStorage.setItem(breadcrumbKey, JSON.stringify({
                path: parentPath,
                timestamp: Date.now()
            }));
            sessionStorage.setItem('breadcrumbsMap_temp', JSON.stringify({
                path: completePath,
                timestamp: Date.now()
            }));
        };
        
        // 1) Collection is in the sidebar tree — original behaviour
        const sidebar = document.querySelector('.sidebar-menu');
        if (sidebar) {
            const allSidebarLinks = sidebar.querySelectorAll('a[href]');
            let activeSidebarLink = null;
            
            for (const link of allSidebarLinks) {
                if (link.getAttribute('href') === pathName) {
                    activeSidebarLink = link;
                    break;
                }
            }
            
            if (activeSidebarLink) {
                const breadcrumbPath = extractBreadcrumbPath(activeSidebarLink);
                
                if (breadcrumbPath.length > 0) {
                    const breadcrumbHTML = buildBreadcrumbHTML(breadcrumbPath);
                    const ulElement = collectionBreadcrumbContainer.closest('ul.items');
                    
                    if (ulElement) {
                        ulElement.outerHTML = `<ul class="items slider slider--desktop">${breadcrumbHTML}</ul>`;
                    }
                    
                    // Store for products clicked from this collection
                    sessionStorage.setItem('breadcrumbsMap_temp', JSON.stringify({
                        path: breadcrumbPath,
                        timestamp: Date.now()
                    }));
                }
                
                breadcrumbsWrapper?.classList.add('js-ready');
                return;
            }
        }
        
        // 2) Cached parent path (reload / direct entry within TTL on a showcase sub-collection)
        const storedData = sessionStorage.getItem(breadcrumbKey);
        if (storedData) {
            try {
                const { path, timestamp } = JSON.parse(storedData);
                if (path?.length && timestamp && (Date.now() - timestamp < MAX_AGE)) {
                    renderFromParentPath(path);
                    breadcrumbsWrapper?.classList.add('js-ready');
                    return;
                }
                sessionStorage.removeItem(breadcrumbKey);
            } catch (e) {
                sessionStorage.removeItem(breadcrumbKey);
            }
        }
        
        // 3) Came from another collection (e.g. Collection Showcase click) — inherit parent path
        if (document.referrer.includes('/collections/')) {
            const tempBreadcrumbs = sessionStorage.getItem('breadcrumbsMap_temp');
            if (tempBreadcrumbs) {
                try {
                    const { path, timestamp } = JSON.parse(tempBreadcrumbs);
                    if (path?.length && timestamp && (Date.now() - timestamp < MAX_AGE)) {
                        renderFromParentPath(path);
                        breadcrumbsWrapper?.classList.add('js-ready');
                        return;
                    }
                } catch (e) {
                    sessionStorage.removeItem('breadcrumbsMap_temp');
                }
            }
        }
        
        breadcrumbsWrapper?.classList.add('js-ready');
    }
    
    // Main function
    function buildBreadcrumbsFromSidebar() {
        cleanExpiredBreadcrumbs();
        
        const pathName = window.location.pathname;
        const breadcrumbsWrapper = document.querySelector('.breadcrumbs');
        
        if (pathName.includes('/products/')) {
            handleProductPage(pathName, breadcrumbsWrapper);
        } else if (pathName.includes('/collections/')) {
            handleCollectionPage(pathName, breadcrumbsWrapper);
        } else {
            breadcrumbsWrapper?.classList.add('js-ready');
        }
    }
    
    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', buildBreadcrumbsFromSidebar);
    } else {
        buildBreadcrumbsFromSidebar();
    }
})();
